import { IPanelGame, IScoresheetClocks } from './types';

export function calculateClock(
  game: IPanelGame,
  color: 'black' | 'white',
  customPlayersTimeMs: IScoresheetClocks | undefined,
  isFirstMoveTime: boolean = false,
) {
  const isWhite = color === 'white';
  const isWhiteMove = game.nextMoveBy === 'White';
  const isInProgress = game.status === 'InProgress';

  const { blackLeftMs, whiteLeftMs, blackStartLeftMs, whiteStartLeftMs } = game.clock ?? {};
  const customTimeMs = customPlayersTimeMs?.[color];
  const rawLeftMs =
    color === 'white'
      ? isFirstMoveTime
        ? (whiteStartLeftMs ?? whiteLeftMs)
        : whiteLeftMs
      : isFirstMoveTime
        ? (blackStartLeftMs ?? blackLeftMs)
        : blackLeftMs;

  const paused =
    rawLeftMs === -1 ||
    (customTimeMs === undefined && isInProgress ? (isWhite ? !isWhiteMove : isWhiteMove) : true);

  const clockControlMs = isWhite
    ? game.whiteClockControlSettings?.initialSeconds
    : game.blackClockControlSettings?.initialSeconds;
  const leftMs =
    isFirstMoveTime && paused && clockControlMs !== undefined ? clockControlMs * 1000 : rawLeftMs;

  return { leftMs, customTimeMs, paused };
}
